export default "__VITE_ASSET__BONtvb4X__"